export function courseTopicPath(courseSlug: string, topicSlug: string, moduleId?: number | null) {
  const path = `/courses/${courseSlug}/topics/${topicSlug}`;
  return moduleId && moduleId > 0 ? `${path}?module=${moduleId}` : path;
}
